import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { storage } from "../../../../Firebase/config";
import PopupContractPrivacyPolicy from "../../../Common/PopupContractPrivacyPolicy";
import { Modal } from "reactstrap";
import { auctionRequest, auctionRequestAPI, updateAuctionStatus } from "../../../../redux/auction/action";
import { takeAndUploadScreenshot } from "../../../../utils/takeAndUploadScreenshot";
import SignContractInput from "../../SignContractInput";
import { rentalAcceptReject } from "../../../../redux/rental/action";

const SignAuctionContract = ({ pbi }) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location;
  const [modal, setModal] = useState(false);

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const formik = useFormik({
    initialValues: {
      first_name: profile?.first_name,
      last_name: profile?.last_name,
      agree: false,
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("First name is required"),
      last_name: Yup.string().required("Last name is required"),
      agree: Yup.boolean().oneOf([true], "You must agree to the terms"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const screenshotUrl = await takeAndUploadScreenshot();

        if (screenshotUrl) {
          hireexpert(screenshotUrl, values);
        } else {
          setLoading(false);
          console.error("Failed to upload screenshot. Please try again.");
        }
      } catch (error) {
        console.error("Error taking or uploading screenshot:", error);
        setLoading(false);
      }
    },
  });


  const hireexpert = (screenshotUrl, values) => {
    if (state?.approvefrom == "buyer") {
      const state = {
        id: pbi?.id,
        bid_id: pbi?.winning_bid[0]?.id,
        type: 3,
        type_of_post: "auction",
        post_id: pbi?.id,
        post_price: pbi?.winning_bid[0]?.payable_amount || pbi?.price,
      };
      const data = {
        ...values,
        "bid_id": id,
        "type": "4",
        image: screenshotUrl,
        url: `/${lan}/account/paymentmethodpage`,
        state: state,
      };

      dispatch(auctionRequest(data, setLoading, navigate))

    }
    else if (state?.approvefrom == "buyerfromlist") {
      const state = {
        id: id,
        type_of_post: "deposit",
        auction_id: id,
        deposit_price: pbi?.deposit_price,
        post_price: pbi?.deposit_price,
      };
      const data = {
        ...values,
        "type": "2",
        "auction_id": id,
        image: screenshotUrl,
      };
      dispatch(auctionRequestAPI(data))
      navigate(`/${lan}/account/paymentmethodpage`, {
        state: {
          orderdetails: { ...state },
        },
      });
    }

    else {
      return null
    }
  };

  const DeclineContract = () => {
    if (state?.approvefrom == "seller" || state?.approvefrom == "buyerfromlist") {
      navigate(-1)
    }
    else if (state?.owner) {
      const data = {
        type: "5",
        bid_id: pbi?.winning_bid[0]?.id,
        id: id
      };
      dispatch(updateAuctionStatus(data));
      navigate(-1)
    } else {
      const data = {
        type: "5",
        bid_id: pbi?.winning_bid[0]?.id,
        id: id
      };
      dispatch(updateAuctionStatus(data));
      navigate(-1)
    }
  };

  console.log(state?.owner, 'state?.owner');

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <SignContractInput formik={formik} />

        <div className="checkbox">
          <input
            type="checkbox"
            id="agree"
            name="agree"
            checked={formik.values.agree}
            onClick={() => {
              if (!formik.values.agree) {
                setModal(true);
              }
              else {
                formik.setFieldValue("agree", !formik.values.agree);
              }
            }}
          />
          <label htmlFor="agree">
            Yes, I understand and agree to Urxprt’s {' '}
            <span>{' '} Terms of Service</span>, including the
            <span>{' '} User Agreement</span> and <span>Privacy Policy</span>.
          </label>
          {formik.touched.agree && formik.errors.agree ? (
            <div className="error">{formik.errors.agree}</div>
          ) : null}
        </div>

        <div className="submit-btn">
          <button
            type="button"
            onClick={() => DeclineContract()}
            className="btn"
          >
            {(state?.approvefrom == "seller" || state?.approvefrom == "buyerfromlist") ? "Back" : "Decline contract"}

          </button>
          <button type="submit" className="btn post-btn" disabled={loading}>
            {loading
              ? "Submitting..."
              : state?.approvefrom == "user"
                ? "Accept & Start project"
                : "Accept"}
          </button>
        </div>
      </form>
      {modal && (
        <Modal
          isOpen={modal}
          keyboard={false}
          className="modal-width modal-centered popupmodal termsconditionmodal"
        >
          <PopupContractPrivacyPolicy formik={formik} setModal={setModal} />
        </Modal>
      )}
    </>
  );
};

export default SignAuctionContract;
